import "./validation";
import { EventBus, FE_RENDER_CHANNEL } from "@ceeferenderer/fe-renderer-sdk";
import { process } from "./process";
import { receiver } from "./receiver";

export const flow = (): void => {
  EventBus.subscribe(FE_RENDER_CHANNEL, receiver);
  process();
};
